// 下载文件用
export function downloadFiles(url, filename) {
    // 实现下来
    const aLink = document.createElement('a');
    document.body.appendChild(aLink);
    aLink.style.display = 'none';
    const filesName = filename
    aLink.href = url
    aLink.setAttribute('download', filesName);
    aLink.click();
    document.body.removeChild(aLink);
}
//下载图片用
export function downloadImage(url, filename) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.onload = function() {
        if (xhr.status === 200) {
            var blob = xhr.response;
            var link = document.createElement('a');
            link.style.display = 'none';
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            var event = document.createEvent('MouseEvents');
            event.initEvent('click', true, false);
            link.dispatchEvent(event);
        }
    };
    xhr.send();
}


// 下载，区别文件和图片
export function downLoad(url, filename) {
    let fileType = ""
    if(url){
        fileType = url.split(".").reverse()[0]
    }
    // png、jpg、txt会直接打开，则请求到后再下载
    if(fileType==="png" || fileType==="jpg" || fileType==="txt"){
        downloadImage(url, filename)
    }else{
        downloadFiles(url, filename)
    }
}


// 下载，区别文件和图片
export function downLoadWithToken(url, filename) {
    let fileType = ""
    if(url){
        fileType = filename.split(".").reverse()[0]
    }
    // png、jpg、txt会直接打开，则请求到后再下载
    if(fileType==="png" || fileType==="jpg" || fileType==="txt"|| fileType==="pdf" || fileType==="mp4"){
        downloadImage(url, filename)
    }else{
        downloadFiles(url, filename)
    }
}
// 下载，只返回文件路径
const BASEPATH = "https://bsc.mnmcloud.com/"
export function downLoadWithoutBaseUrl(url, filename) {
    const fullUrl = `${BASEPATH}${url}`
    let fileType = ""
    if(url){
        fileType = filename.split(".").reverse()[0]
    }
    // png、jpg、txt会直接打开，则请求到后再下载
    if(fileType==="png" || fileType==="jpg" || fileType==="txt"|| fileType==="pdf" || fileType==="mp4"){
        downloadImage(fullUrl, filename)
    }else{
        downloadFiles(fullUrl, filename)
    }
}
